import { jsx as _jsx } from "react/jsx-runtime";
import { useGenerateScriptPanelContext } from '@/hoc/context/generate-script-panel-context';
import { ScriptConfigurationKanbanPanel } from '../script-config';
import { ThemeConfigurationKanbanPanel } from '../theme-config/theme-config-kanban-panel';
export var GenerateScriptKanbanPanel = function () {
    var _a = useGenerateScriptPanelContext(), configuration = _a.configuration, isThemePanelOpen = _a.isThemePanelOpen, setConfiguration = _a.setConfiguration, setTheme = _a.setTheme, theme = _a.theme;
    if (isThemePanelOpen) {
        return (_jsx(ThemeConfigurationKanbanPanel, { theme: theme, setTheme: setTheme, configuration: configuration, setConfiguration: setConfiguration }));
    }
    return (_jsx(ScriptConfigurationKanbanPanel, { configuration: configuration, setConfiguration: setConfiguration }));
};
